module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-info"
  }, [(_vm.user) ? _c('h3', {
    staticClass: "b f3"
  }, [_vm._v(_vm._s(_vm.user.prenom) + " " + _vm._s(_vm.user.nom))]) : _vm._e(), _c('sign-out')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff413536"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/layouts/login/user-info.vue
// module id = 1372
// module chunks = 1